import { render, staticRenderFns } from "./CamaraAlertaPantalla.vue?vue&type=template&id=0d421d6e&scoped=true&"
import script from "./CamaraAlertaPantalla.vue?vue&type=script&lang=ts&"
export * from "./CamaraAlertaPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d421d6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0d421d6e', component.options)
    } else {
      api.reload('0d421d6e', component.options)
    }
    module.hot.accept("./CamaraAlertaPantalla.vue?vue&type=template&id=0d421d6e&scoped=true&", function () {
      api.rerender('0d421d6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/Alerta/CamaraAlertaPantalla.vue"
export default component.exports